import React from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';

const UltimasNoticias = ({ noticias }) => {
    
    return(
        <div className="container">
            <div className="row">
              <div className="col-md-6">
                  <h3 className="wow fadeInUp titulo">Últimas Notícias</h3>
                  <div className="spacer-20"></div>
              </div>
              <div className="col-lg-6 text-lg-end">
                  <Link className="mb-sm-30 mt-4 titulo" to="/noticias">Ver Mais Notícias</Link>
              </div>
            </div>
            <div className="row g-4 sequence">
                {noticias.map((noticia) => (
                    <div className="col-lg-4 col-md-6 gallery-item" key={noticia.id}>
                        <div className="de-item wow">  
                        <Link to={`/noticia/${noticia.url}`}>
                            <img src={noticia.foto} className="img-fluid " alt={noticia.titulo}/>
                        </Link>
                        </div>
                        <div className="post-text">
                            <div className="d-date">
                            {noticia.data_publicacao && !isNaN(new Date(noticia.data_publicacao).getTime())
                            ? format(new Date(noticia.data_publicacao), 'dd/MM/yyyy')
                            : ''}
                            </div>
                            <h4>
                            <Link to={`/noticia/${noticia.url}`}>{noticia.titulo}<span></span></Link>
                            </h4>
                            <p className="previa">{noticia.previa}</p>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
}

export default UltimasNoticias;